import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";
import BadgePopup from "../components/Badgepopup";
function BitcoinTechPage71() {
  const contentRef = useRef(null);
    const [isOpen, setIsOpen] = useState(true);
  const titleText = "A Primer on What Bitcoin Is and How It Works";
  const links = {
    prev: "/index-bitcoin-tech",
    index: "/index-bitcoin-tech",
    next: "/bitcoin-tech-page-72",
  };
  const questions = [
    {
      text: "1. What is the primary reason Bitcoin has a fixed supply of 21 million coins?",
      options: [
        {
          value: "A",
          label: "A. To prevent inflation and ensure scarcity",
        },
        {
          value: "B",
          label: "B. To allow central banks to control its supply",
        },
        {
          value: "C",
          label: "C. To make mining easier over time",
        },
        {
          value: "D",
          label:
            "D. To ensure every person on Earth can own at least one Bitcoin",
        },
      ],
      correct: "A",
    },
    {
      text: "2. How does Bitcoin achieve decentralization?",
      options: [
        {
          value: "A",
          label: "A. By allowing central banks to verify transactions",
        },
        {
          value: "B",
          label:
            "B. By having a network of independent nodes verify and secure transactions",
        },
        {
          value: "C",
          label: "C. By storing Bitcoin balances in a centralized database",
        },
        {
          value: "D",
          label:
            "D. To ensure every person on Earth can own at least one Bitcoin",
        },
      ],
      correct: "B",
    },
    {
      text: "3. What role do Bitcoin miners play in the network?",
      options: [
        {
          value: "A",
          label: "A. They create new Bitcoin addresses for users",
        },
        {
          value: "B",
          label:
            "B. They solve cryptographic puzzles to secure transactions and add them to the blockchain",
        },
        {
          value: "C",
          label: "C. They set transaction fees for the entire network",
        },
        {
          value: "D",
          label: "D. They approve transactions based on government regulations",
        },
      ],
      correct: "B",
    },
    {
      text: "4. What is one key advantage of Bitcoin over traditional banking systems?",
      options: [
        {
          value: "A",
          label: "A. Transactions can be reversed easily if there is a mistake",
        },
        {
          value: "B",
          label:
            "B. Bitcoin can be sent globally without requiring permission from a central authority",
        },
        {
          value: "C",
          label:
            "C. It requires an internet connection and government approval to function",
        },
        {
          value: "D",
          label: "D. Bitcoin transactions are always free",
        },
      ],
      correct: "B",
    },
  ];

  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);
  return (
    <div className="container">
      <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={71}
        timerMinutes={60}
        currentLevel={6}
        unlockedBadges={11}
      />

      <p className="content" ref={contentRef}>
        Welcome to <b>Day 71</b>! Congratulations on making it this far in your
        Bitcoin journey! Over the past few weeks, you've explored the
        foundational concepts of Islamic Jurispudence on finance, and the
        principles of Austrian Economics, and their role in the modern financial
        system. But now, it's time to dive deeper into the technical heart of
        Bitcoin, the intricate mechanics that make it work seamlessly as a
        decentralized, trustless network. <br />
        From this point forward, we will unravel the inner workings of Bitcoin’s
        protocol, dissect its code, and explore the powerful cryptographic and
        game-theoretic principles that secure the network. Whether it's Bitcoin
        Script, mining, difficulty adjustment, or consensus rules, we’ll be
        breaking them down into digestible, engaging lessons that will
        strengthen your technical understanding of Bitcoin. Get ready because
        today marks the beginning of a thrilling deep dive into the very core of
        Bitcoin’s technology!
        <br />
        <br />
        <b>What is Bitcoin?</b>
      </p>
      <img src="/bitcoin_question.png" className="content-image" alt=""></img>
      <p className="content">
        You must have read various terms on the internet or heard from your
        friends and colleagues that Bitcoin is a cryptocurrency, digital gold,
        electronic cash, or even magic internet money! But at its core, Bitcoin
        is much more than just a currency, and the most comprehensive way to
        define it is that Bitcoin is a collection of concepts and technologies
        that form the foundation of a revolutionary digital money ecosystem.{" "}
        <br />
        It was introduced in 2008 by an anonymous entity using the pseudonym
        Satoshi Nakamoto and launched in 2009 as an open-source project. Unlike
        traditional currencies issued by governments, Bitcoin operates on a
        trustless system, where transactions are verified by network
        participants through cryptographic algorithms.
        <br />
        At the heart of Bitcoin lies the blockchain, a transparent and tamper
        resistant digital ledger that records every transaction securely. This
        groundbreaking technology ensures that no single entity has control over
        the network, making Bitcoin censorship resistant and permissionless.{" "}
        <br />
        Bitcoin is not just another form of money. It is a movement, a financial
        revolution designed to empower individuals, restore financial
        sovereignty, and redefine how we think about value in the digital age.
        <br />
        <br />
        <b>Why Was Bitcoin Created?</b>
      </p>
      <img src="/chancellor.jpg" width="500px"></img>
      <p className="content">
        Money is the lifeblood of a civilization. It enables trade, stores
        value, and facilitates economic cooperation. However, for much of
        history, money has been controlled by central authorities, leading to
        periods of inflation, devaluation, and financial instability. The
        creation of Bitcoin in 2008 was a response to these issues, offering an
        alternative financial system free from government control and
        manipulation.
        <br />
        In the wake of the 2008 global financial crisis, Satoshi Nakamoto
        created Bitcoin as a decentralized alternative to a banking system
        reliant on government intervention. The Genesis Block famously contains
        the headline, "The Times 03/Jan/2009 Chancellor on brink of second
        bailout for banks," serving as both a timestamp and a permanent critique
        of traditional finance. By hard-coding this message into the network's
        foundation, Satoshi highlighted the inherent instability of fiat
        currencies where central authorities can inflate the money supply or use
        public funds to rescue failing institutions and offered Bitcoin as a
        peer-to-peer system that requires no "trusted" middleman.
        <br />
        <br />
        <b>The Need for a Universal Currency:</b>
        <br />
        <br />
        There are over 160 official currencies in the world, each restricted by
        the jurisdiction of the government that issues it. The limitations of
        these national currencies mean that money is only fully usable within
        specific borders. If someone from the United States wishes to conduct
        business in Japan, they must first exchange their U S dollars for
        Japanese yen, which comes with transaction costs and fluctuations in
        value.
        <br />
        The need for a currency that is saleable across space that is, globally
        accepted and not restricted by national borders was long apparent. A
        truly universal currency would eliminate inefficiencies in global trade
        and provide a stable store of value beyond the control of any single
        government. Bitcoin was created to fulfill this role, offering a
        decentralized, borderless, and finite form of money.
        <br />
        <br />
        <b>The Problem with Fiat Money:</b>
        <br />
        <br />
        For most of history, money was backed by scarce commodities like gold
        and silver, which constrained its supply and preserved its value.
        However, in 1971, U S President Richard Nixon made a pivotal decision
        that changed the global monetary system forever. <br />
        He announced "We must protect the position of the American dollar as a
        pillar of monetary stability around the world. In order to do so, I have
        directed the Secretary of the Treasury to suspend temporarily the
        convertibility of the dollar into gold." This move effectively abolished
        the gold standard, transitioning the world to a fiat currency system
        where money is backed only by the trust in governments. Since then,
        central banks have had the power to issue money at will, leading to
        rampant inflation, economic bubbles, and the erosion of people’s
        savings. Inflation disproportionately affects the working and middle
        classes, who see their purchasing power diminish while assets like real
        estate and stocks owned primarily by the wealthy rise in price. Bitcoin
        was designed to solve this problem. Unlike fiat currencies, which can be
        printed endlessly, Bitcoin has a fixed supply of 21 million coins. No
        central authority can create more Bitcoin, ensuring its scarcity and
        protecting it from inflationary pressures.
        <br />
        <br />
        <b>The Cypherpunk Movement and Early Attempts at Digital Currency:</b>
        <br />
        <br />
        Bitcoin was not the first attempt at creating a digital currency. Since
        the 1990s, cryptographers and privacy advocates known as the cypherpunks
        have been working to develop decentralized digital money. One of the
        earliest attempts was Chaumian cash, developed by David Chaum in the
        late 1980s. Chaumian cash introduced cryptographic techniques to enhance
        privacy, allowing for transactions that could not be easily traced.
        However, it relied on a central authority to validate transactions,
        making it susceptible to regulatory shutdown. This reliance on a
        centralized entity ultimately led to its downfall. Another attempt was
        Hashcash, created by Adam Back in the 1990s. Hashcash introduced a proof
        of work system to combat email spam but was later considered as a
        potential foundation for digital money. However, Hashcash lacked a
        decentralized ledger, making it difficult to prevent double spending.
        Other projects like e gold and Liberty Reserve also attempted to create
        digital currencies, but their centralized nature meant they could be
        shut down by regulators. These failures highlighted the necessity of a
        decentralized system one where no single entity could control the
        currency.
        <br />
        Bitcoin was born out of the cypherpunk ethos, designed to be a
        decentralized and censorship resistant form of money. Satoshi Nakamoto,
        the pseudonymous creator of Bitcoin, built upon previous cryptographic
        advancements to solve the double spending problem using blockchain
        technology a distributed ledger that ensures transactions are verified
        by a decentralized network of nodes.
        <br />
        <br />
        <b>Bitcoin A Sly Roundabout the State:</b>
        <br />
        <br />
        Austrian economist Friedrich Hayek once said, "I don’t believe we shall
        ever have good money again before we take the thing out of the hands of
        government, that is, we can’t take it violently out of the hands of
        government, all we can do is by some sly, roundabout way introduce
        something that they can’t stop." Bitcoin embodies Hayek’s vision. It is
        a monetary system that operates beyond the reach of governments and
        central banks, ensuring financial sovereignty for its users. By removing
        the need for trusted intermediaries, Bitcoin empowers individuals to
        take control of their wealth without fear of censorship or devaluation.
        <br />
        <br />
        <b>The Importance of Sound Money:</b>
        <br />
        <br />
        A civilization cannot be stable without sound money. Throughout history,
        monetary instability has led to economic collapse, social unrest, and
        loss of trust in institutions. When money is unsound prone to inflation
        and government manipulation it distorts economic decision making,
        discourages long term savings, and fuels wealth inequality. Bitcoin
        offers an alternative. With its fixed supply, decentralized nature, and
        security through cryptographic proof, it provides a form of money that
        is resistant to political interference. Unlike fiat currencies, which
        require trust in central banks, Bitcoin operates on an open source
        protocol that anyone can verify.
        <br />
        <br />
        Bitcoin is a response to the fundamental flaws of the fiat monetary
        system. It addresses the problems of inflation, centralization, and the
        lack of a universal currency by providing a decentralized, scarce, and
        globally accessible form of money. By solving these issues, Bitcoin
        represents not just a technological innovation but a monetary revolution
        one that has the potential to redefine the global financial landscape.
        As Bitcoin adoption grows, it challenges the traditional financial
        order, offering individuals a way to preserve wealth, conduct borderless
        transactions, and opt out of government controlled monetary policies. In
        a world where financial systems are increasingly unstable, Bitcoin
        stands as a beacon of economic freedom and financial sovereignty. It is
        not just a new form of money it is the return of sound money.
        <br />
        <br />
        Thus, Bitcoin was created to solve several fundamental problems within
        the traditional financial system.
        <br /> These problems include:
        <br />
        <ul>
          <li>
            Centralized Control of Money: Governments and central banks control
            the supply of traditional currencies (fiat money), leading to
            inflation and monetary policies that may not always benefit
            individuals. Bitcoin eliminates this issue by having a fixed supply
            of 21 million coins, ensuring scarcity and preventing arbitrary
            inflation.
          </li>
          <li>
            Lack of Financial Privacy: Traditional payment systems require users
            to share sensitive financial information, making them vulnerable to
            surveillance, fraud, and identity theft. Bitcoin provides
            pseudonymity, allowing users to conduct transactions without
            revealing personal details.
          </li>
          <li>
            {" "}
            High Transaction Costs and Slow Settlements: International wire
            transfers can take days to process and involve significant fees.
            Bitcoin transactions, on the other hand, settle within minutes and
            can be sent across borders with minimal fees.
          </li>
          <li>
            Exclusion from Banking Systems: Over 1.7 billion people worldwide
            lack access to traditional banking services. Bitcoin enables
            financial inclusion by allowing anyone with an internet connection
            to participate in the global economy.
          </li>
          <li>
            {" "}
            Elimination of Third-Party Risk: Traditional financial transactions
            often require trusting third parties, such as banks, payment
            processors, and financial institutions, which can introduce
            counterparty risk. Bitcoin eliminates this need by enabling direct
            transactions between participants without requiring intermediaries.
          </li>
        </ul>
        <br />
        <br />
        <b>Key Features of Bitcoin</b>
        <br />
        <br />
        Bitcoin is a revolutionary form of money that challenges the traditional
        financial system by offering a decentralized, secure, and globally
        accessible alternative. Unlike government-issued currencies, Bitcoin
        operates on a peer-to-peer network without reliance on banks or
        intermediaries. Its design incorporates key features that make it a
        powerful financial tool, particularly in an era of increasing monetary
        instability and financial surveillance. From its limited supply to its
        censorship-resistant nature, Bitcoin provides individuals with a way to
        store and transfer value with unprecedented freedom and security.
        Understanding these fundamental features is crucial to grasping why
        Bitcoin is reshaping the global economy.
        <br />
        <ul>
          <li>
            {" "}
            Decentralization: Unlike traditional currencies controlled by
            central banks, Bitcoin is maintained by a global network of
            decentralised nodes (computers that help maintain and secure the
            Bitcoin network). It is practically infeasible for a single entity
            to manipulate or shut down the Bitcoin network.
          </li>
          <li>
            {" "}
            Limited Supply: Bitcoin has a hard cap of 21 million coins,
            preventing inflation. This scarcity of issuance is unprecedented,
            making Bitcoin a hedge against inflation.
          </li>
          <li>
            Borderless and Permissionless: Bitcoin can be sent anywhere in the
            world without requiring permission from a central authority. This
            makes it a powerful tool for individuals in restrictive financial
            environments.
          </li>
          <li>
            Security and Transparency: Every Bitcoin transaction is recorded on
            the blockchain, making the system transparent and auditable. At the
            same time, Bitcoin’s cryptographic security ensures that
            transactions cannot be tampered with.
          </li>
          <li>
            Censorship Resistance: Governments and financial institutions cannot
            arbitrarily freeze or reverse Bitcoin transactions, ensuring
            financial sovereignty for its users.
          </li>
          <li>
            Divisibility and Portability: Bitcoin is highly divisible, with the
            smallest unit called a satoshi (0.00000001 BTC), allowing
            microtransactions. It is also easily portable, as it exists
            digitally and can be accessed globally with an internet connection.
          </li>
        </ul>
        <b>How Does Bitcoin Work?</b>
        <br />
        <br />
        Bitcoin operates on a proof-of-work (PoW) consensus mechanism, which
        secures the network and verifies transactions. Here’s how a Bitcoin
        transaction works: <br />
        <ul>
          <li>
            Initiating a Transaction:A user sends Bitcoin from their wallet to
            another wallet using a public Bitcoin address. The transaction is
            signed using a digital signature, ensuring security and
            authenticity.
          </li>
          <li>
            Transaction Broadcast and Verification: The transaction is broadcast
            to the Bitcoin network. Nodes (computers running Bitcoin software)
            verify the transaction to ensure the sender has sufficient funds and
            that the signature is valid.
          </li>
          <li>
            {" "}
            Mining and Block Inclusion: Miners compete to solve a cryptographic
            puzzle (proof-of-work) to add the transaction to a new block. The
            winning miner adds the block to the blockchain and receives a block
            reward (newly minted Bitcoin + transaction fees).
          </li>
          <li>
            {" "}
            Finalization and Confirmation: Once a transaction is included in a
            block, it is considered confirmed. The more blocks that are added on
            top of it, the more secure the transaction becomes.
          </li>
        </ul>
        <b>Bitcoin Mining: The Backbone of The Network</b>
      </p>
      <img src="bitcoin-mining.png" className="content-image"></img>
      <p className="content">
        Bitcoin mining is the process by which new bitcoins are created and
        transactions are confirmed. Miners use powerful computers to solve
        complex mathematical puzzles. This process secures the Bitcoin network
        and prevents fraud. When a miner successfully solves a puzzle, they add
        a new block of transactions to the blockchain and receive a reward in
        newly minted bitcoins. This system ensures that no single entity
        controls Bitcoin and that transactions remain decentralized. Mining also
        regulates Bitcoin’s supply, as rewards decrease over time, making
        Bitcoin increasingly scarce. Essentially, mining is how Bitcoin
        maintains security, verifies transactions, and issues new coins. <br />
        <br />
        <b>Some key aspects of Bitcoin Mining are:</b> <br />
        <br />
        <ul>
          <li>
            Mining Difficulty and Halving Events: The Bitcoin network adjusts
            mining difficulty approximately every two weeks to maintain a
            consistent block production rate (~10 minutes per block). Every
            210,000 blocks (~every 4 years), the Bitcoin block reward undergoes
            a halving, reducing the number of new coins created. This ensures
            controlled issuance and strengthens Bitcoin’s scarcity over time.
            Bitcoin’s proof-of-work mining requires significant energy, leading
            to concerns about its environmental impact. However, the energy
            consumption debate must be viewed in context. Over time, Bitcoin
            mining hardware has become more efficient, reducing energy
            consumption per transaction. Studies show that Bitcoin’s total
            energy consumption is significantly lower than that of the global
            banking system and gold mining industry.{" "}
          </li>
          <li>
            Stranded Energy Utilization: Bitcoin mining can monetize wasted or
            stranded energy sources that would otherwise go unused. Innovations
            in Bitcoin mining, such as the use of excess methane gas from oil
            fields and improvements in ASIC efficiency, continue to make the
            network more sustainable over time.
          </li>
        </ul>
        <br />
        <br />
        <b>How to Get Started with Bitcoin</b>
        <br />
        <br />
        “I think it’s important to recognize that not everyone needs this
        technology. Also, the technology is not ready for everyone. It is still
        difficult to use, difficult to secure, it’s difficult to operate in a
        convenient way. The user interfaces are very poor, require a high level
        of technical expertise to operate, even more so to operate securely. And
        so, why do you need it in your life?” – Andreas Antonopoulos, author of
        Mastering Bitcoin.
        <br />
        This quote highlights that while Bitcoin offers significant advantages,
        it is not yet easy for everyone to use. Security and self-custody
        require effort, and the tools available today still have a steep
        learning curve. Unlike traditional banking, where transactions are
        reversible and accounts can be recovered, Bitcoin demands a high level
        of responsibility from its users. This means that individuals must
        educate themselves before diving in, as mistakes can be costly. <br />
        For new users, the benefits of Bitcoin are not always immediately clear,
        while its challenges are obvious. Interacting with Bitcoin can feel
        intimidating, especially when dealing with long cryptographic addresses,
        QR codes, and irreversible transactions. Many first-time users
        experience anxiety when sending funds, fearing they might lose them due
        to a small mistake. Unlike traditional banking apps, Bitcoin wallets
        demand a different mindset, one where security and privacy are in the
        hands of the user rather than a third party. This can feel overwhelming,
        but with the right approach, users can onboard Bitcoin in a way that
        aligns with their technical knowledge and risk tolerance. <br />
        <br />
        To begin, it is essential to choose a Bitcoin storage method that suits
        your level of expertise and needs: <br />
        <ul>
          <li>
            Full Node + Hardware Wallet: If you prioritize security over ease of
            use and want to independently validate the entire Bitcoin
            blockchain, running a full node alongside a hardware wallet is the
            best choice. This setup ensures maximum privacy, security, and
            self-sovereignty.
          </li>
          <li>
            SPV Node / Light Wallet If you value security but do not want to
            download and validate the entire blockchain, an SPV (Simplified
            Payment Verification) or light wallet is a good compromise. It
            allows you to verify transactions without relying entirely on third
            parties.
          </li>
          <li>
            Hot / Web Wallet If you prioritize ease of use over security but
            still want to control your private keys, a hot wallet (mobile or
            desktop) is a convenient option. However, since it remains connected
            to the internet, it is more vulnerable to hacks.
          </li>
          <li>
            Exchange / Custodial Wallet If ease of use is your top priority and
            you do not want the responsibility of managing private keys, using
            an exchange or a custodial wallet is the simplest option. However,
            this comes with the risk of relying on a third party to safeguard
            your funds.
          </li>
        </ul>
        <br />
        After understanding the different ways to interact with Bitcoin, you can
        choose the storage method that best aligns with your priorities:
        <br />
        Selecting the right storage method depends on your personal needs and
        technical comfort level. If you're new to Bitcoin, it’s best to start
        with a simple option and gradually transition to more secure methods as
        you gain experience.
        <br />
        <br />
        <b>Buying Bitcoin</b>
        <br />
        <br />
        There are multiple options available to acquire Bitcoin depending on
        your preferences, security concerns, and local regulations.
        <br /> Whether you want to buy Bitcoin instantly, earn it through work,
        or mine it yourself, each method has its own advantages and trade-offs.
        Below are the most common ways to obtain Bitcoin:{" "}
        <ul>
          <li>
            Exchanges: Centralized platforms like Binance, Coinbase, and Kraken
            allow users to purchase Bitcoin using fiat currencies such as USD,
            EUR, or JPY. They offer convenience and liquidity but require
            identity verification (KYC) and custody of funds, unless withdrawn
            to a private wallet.
          </li>
          <li>
            Peer-to-Peer (P2P): Tradin Platforms like Bisq and HodlHodl
            facilitate direct transactions between buyers and sellers without
            intermediaries. P2P trading offers greater privacy and censorship
            resistance but requires more caution to avoid scams.
          </li>
          <li>
            Mining: By running specialized hardware (ASIC miners), you can
            contribute computing power to the Bitcoin network and receive newly
            minted Bitcoin as a reward. However, mining requires significant
            investment in equipment, electricity, and technical expertise.
            4.Earning Bitcoin: Instead of buying Bitcoin, you can earn it by
            accepting payments for products, services, or free
          </li>
          <li>
            Earning Bitcoin: Instead of buying Bitcoin, you can earn it by
            accepting payments for products, services, or freelance work. Many
            platforms facilitate Bitcoin payments, allowing workers, businesses,
            and content creators to integrate Bitcoin into their income streams.
          </li>
          <li>
            Bitcoin ATMs: These machines, available in many cities worldwide,
            enable users to purchase Bitcoin using cash, debit, or credit cards.
            While convenient, Bitcoin ATMs often have higher fees compared to
            exchanges and may require identity verification.
          </li>
        </ul>
        <br />
        Choosing the right method depends on your needs, risk tolerance, and
        familiarity with Bitcoin transactions. If you’re new, using an exchange
        or Bitcoin ATM may be the simplest approach, while more
        privacy-conscious users may prefer P2P trading or earning Bitcoin
        directly.
        <br />
        <br />
        Bitcoin is more than just a digital currency, it’s a monetary
        revolution. It provides financial independence, security, and censorship
        resistance. Understanding its fundamentals is the first step in grasping
        the potential impact of decentralized finance. In the next lesson, we
        will explore the technical components of Bitcoin, including public &
        private keys, addresses, and wallets.
        <br />
        As we progress further in the session we will understand in much more
        detail the components and attributes of Bitcoin which we covered today!!
      </p>

      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)}
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />
 <BadgePopup
  isOpen={isOpen}
  setIsOpen={setIsOpen}
  level="Level 6"
  badgeImg="./achieve.png"
  heading="Bitcoin Navigator"
  subtitle="Beginner - Fundamentals of Bitcoin Tech"
  mainImg="./bitcoinnavigator.png"
  description="Awarded for taking your first steps into Bitcoin’s technical foundations. You have begun understanding how nodes, transactions, blocks, and consensus work together to form a trustless monetary system."
/>

    </div>
  );
}

export default BitcoinTechPage71;
